import React from 'react';
import logo from '../../assets/images/big-c.jpg';
import './main.css';

// ===== แก้ไขลิงก์ช่องทางติดตามได้ที่นี่ =====
const FOLLOW_CHANNELS = [
  {
    id: 'line',
    label: 'Line Official',
    sub: 'กดติดตามรับข่าวสารก่อนใคร',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.070 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
      </svg>
    ),
    color: '#06C755',
    bg: 'rgba(74,201,56,0.12)',
    href: 'https://lin.ee/kdPg469',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    sub: 'Like & Follow เพจของเรา',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
    color: '#1877F2',
    bg: 'rgba(24,119,242,0.10)',
    href: 'https://www.facebook.com/BigCBigService',
  },
  {
    id: 'website',
    label: 'Big C Online',
    sub: 'Big C Online | สั่งง่าย ส่งไว ส่งฟรี',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    color: '#4ac938',
    bg: 'rgba(74,201,56,0.10)',
    href: 'https://www.bigc.co.th',
  }
];
// ================================================

const styles = `
.gfc-page {
  font-family: 'Kanit', 'Segoe UI', sans-serif;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 40px;
  position: relative;
  overflow: hidden;
}

/* subtle bg glow matching green theme */
.gfc-page::before {
  content: '';
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 340px;
  height: 340px;
  background: radial-gradient(circle, rgba(74,201,56,0.10) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

/* Logo */
.gfc-logo-wrap {
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}
.gfc-logo {
  width: 88px;
  height: auto;
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(0,0,0,0.14);
}

/* Badge */
.gfc-badge {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(74,201,56,0.12);
  border: 1.5px solid rgba(74,201,56,0.35);
  color: #27b113;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  padding: 5px 14px;
  border-radius: 999px;
  margin-bottom: 16px;
}
.gfc-badge-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ac938;
  box-shadow: 0 0 6px rgba(74,201,56,0.6);
}

/* Hero text */
.gfc-hero {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 28px;
  margin-bottom: 24px;
}
.gfc-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  margin: 0 0 8px;
}
.gfc-title-accent { color: #27b113; }
.gfc-subtitle {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

/* Card */
.gfc-card {
  position: relative;
  z-index: 1;
  width: calc(100% - 48px);
  max-width: 360px;
  background: linear-gradient(135deg, #4ac938 0%, #27b113 100%);
  border-radius: 22px;
  padding: 22px 20px;
  text-align: center;
  box-shadow:
    0 14px 30px rgba(38,178,75,0.30),
    0 4px 10px rgba(38,178,75,0.20);
  margin-bottom: 28px;
  overflow: hidden;
}
.gfc-card::after {
  content: '🎊';
  position: absolute;
  top: -12px;
  right: -8px;
  font-size: 60px;
  opacity: 0.12;
  transform: rotate(20deg);
  pointer-events: none;
}
.gfc-card-emoji {
  font-size: 40px;
  line-height: 1;
  display: block;
  margin-bottom: 8px;
}
.gfc-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 5px;
}
.gfc-card-desc {
  font-size: 12px;
  color: rgba(255,255,255,0.85);
  line-height: 1.65;
  margin: 0;
}

/* Divider */
.gfc-divider {
  position: relative;
  z-index: 1;
  width: calc(100% - 48px);
  max-width: 360px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.gfc-divider-line {
  flex: 1;
  height: 1px;
  background: rgba(74,201,56,0.20);
}
.gfc-divider-label {
  font-size: 11px;
  font-weight: 700;
  color: #999;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  white-space: nowrap;
}

/* Channel buttons */
.gfc-channels {
  position: relative;
  z-index: 1;
  width: calc(100% - 48px);
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gfc-channel-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255,255,255,0.75);
  border: 1.5px solid rgba(74,201,56,0.15);
  border-radius: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.gfc-channel-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(74,201,56,0.18);
  border-color: rgba(74,201,56,0.40);
}
.gfc-channel-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.gfc-channel-icon {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gfc-channel-info { flex: 1; }
.gfc-channel-name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 1px;
}
.gfc-channel-sub {
  font-size: 11px;
  color: #888;
  margin: 0;
}
.gfc-channel-arrow { color: #ccc; flex-shrink: 0; }

/* Footer */
.gfc-footer {
  position: relative;
  z-index: 1;
  margin-top: 28px;
  font-size: 11px;
  color: #bbb;
  text-align: center;
}

/* Animations */
@keyframes gfc-fadeUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}
.gfc-logo-wrap { animation: gfc-fadeUp 0.5s ease both; }
.gfc-badge     { animation: gfc-fadeUp 0.5s 0.05s ease both; }
.gfc-hero      { animation: gfc-fadeUp 0.5s 0.10s ease both; }
.gfc-card      { animation: gfc-fadeUp 0.5s 0.15s ease both; }
.gfc-divider   { animation: gfc-fadeUp 0.5s 0.20s ease both; }
.gfc-channels  { animation: gfc-fadeUp 0.5s 0.25s ease both; }
.gfc-footer    { animation: gfc-fadeUp 0.5s 0.30s ease both; }

/* Responsive */
@media (max-width: 320px) {
  .gfc-title { font-size: 18px; }
  .gfc-card  { padding: 18px 14px; }
  .gfc-channel-btn { padding: 10px 12px; }
}
`;

const GameFortuneClose = () => (
  <>
    <style>{styles}</style>
    <div className="app-game">
      <main className="phone">
        <img className="logo-image" src={logo} alt="Big C logo" />

        {/* Badge */}
        <div className="gfc-badge">
          <span className="gfc-badge-dot" />
          สิ้นสุดกิจกรรมแล้ว
        </div>

        {/* Hero */}
        <div className="gfc-hero">
          <h1 className="gfc-title">
            ขอบคุณทุกคน<br />
            ที่ร่วม<span className="gfc-title-accent">สนุกไปด้วยกัน</span> 🎉
          </h1>
          <p className="gfc-subtitle">
            กิจกรรมได้สิ้นสุดลงแล้ว<br />
            อย่าลืมติดตามกิจกรรมสุดพิเศษครั้งต่อไป!
          </p>
        </div>

        {/* Card */}
        <div className="gfc-card">
          <span className="gfc-card-emoji">🌟</span>
          <p className="gfc-card-title">กิจกรรมใหม่กำลังจะมา</p>
          <p className="gfc-card-desc">
            ติดตามช่องทางของเราเพื่อไม่พลาด<br />
            กิจกรรมและโปรโมชั่นสุดพิเศษจาก Big C
          </p>
        </div>

        {/* Divider */}
        <div className="gfc-divider">
          <span className="gfc-divider-line" />
          <span className="gfc-divider-label">ติดตามเราได้ที่</span>
          <span className="gfc-divider-line" />
        </div>

        {/* Channels */}
        <div className="gfc-channels">
          {FOLLOW_CHANNELS.map((ch) => (
            <a
              key={ch.id}
              href={ch.href}
              target="_blank"
              rel="noopener noreferrer"
              className="gfc-channel-btn"
            >
              <div className="gfc-channel-icon" style={{ background: ch.bg, color: ch.color }}>
                {ch.icon}
              </div>
              <div className="gfc-channel-info">
                <p className="gfc-channel-name">{ch.label}</p>
                <p className="gfc-channel-sub">{ch.sub}</p>
              </div>
              <svg className="gfc-channel-arrow" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" width="14" height="14">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </a>
          ))}
        </div>

        <p className="gfc-footer">© Big C Supercenter – ขอบคุณที่ไว้วางใจเสมอมา</p>
      </main>

    </div>
  </>
);

export default GameFortuneClose;